import Vue from 'vue';
import 'vant/lib/index.css';
import { Cell, CellGroup, IndexBar, IndexAnchor, NavBar, Button, Icon, Tabbar, TabbarItem,Swipe, SwipeItem,Grid, GridItem, Image, Picker, Sticky , Popup, Tag, Tab, Tabs, List, Form, Field, RadioGroup, Radio, Uploader, Checkbox, CheckboxGroup, Dialog, Rate, Loading, Lazyload  } from 'vant';

// 方式一. 通过 Vue.use 注册
// 注册完成后，在模板中通过 <van-button> 或 <VanButton> 标签来使用按钮组件
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(NavBar);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Image);
Vue.use(Picker);
Vue.use(Sticky );
Vue.use(Popup);
Vue.use(Tag);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Form);
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Dialog);
Vue.use(Rate);
Vue.use(Loading);
Vue.use(Uploader);
Vue.use(Lazyload)




// WEBPACK FOOTER //
// ./src/vant/index.js